const disableScroll = () => {
  const scrollY = window.scrollY
  document.body.classList.add('disable-scroll')
  document.body.style.top = `-${scrollY}px`
}

const enableScroll = () => {
  const scrollY = parseInt(document.body.style.top, 10)
  document.body.classList.remove('disable-scroll')
  document.body.style.top = ''
  window.scrollTo(0, Math.abs(scrollY))
}

const updateTourState = selector => {
  if ('localStorage' in window && window['localStorage'] !== null) {
    // Local storage is available0
    let tourState = JSON.parse(localStorage.getItem('sponsored-tour'))

    tourState[selector] = true

    localStorage.setItem('sponsored-tour', JSON.stringify(tourState))
  } else {
    // Local storage is not available
    console.log('Localstorage not available. Please check your browser settings.')
  }
}

export { disableScroll, enableScroll, updateTourState }
